import PortraitManager from "./PortraitManager";

export default PortraitManager;
export { PortraitManager };
